import { FormOperation } from "@/modules/GeneralRules/models/FormOperation.model";
import { Component, Prop, Vue } from "vue-property-decorator";
import lodash from "lodash";
import Vuetify from "vuetify";
import {
  FORM_ACTION_CONSTANTS,
  OPERATION_INIT
} from "../../constants/FormActionModal.constants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import OperationElement from "../OperationElement/OperationElement.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

Vue.use(Vuetify);
@Component({
  name: "OperationComponent",
  components: {
    OperationElement
  }
})
export default class OperationComponent extends Vue {
  @Prop() formToGenerate!: FormStatus | string;
  @Prop() formOperationsArray!: FormOperation[];
  @Prop() formInformationArray!: FormInformation[];
  @Prop() formTemplates!: FormStatus[];

  primaryIconClass = STYLE_CLASSES.PRIMARY_ICON;
  primaryRoundBtnClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  cardClass = STYLE_CLASSES.CARD_2;
  requiredFieldObject = [FORM_VALIDATORS.REQUIRED_OBJECT];
  requiredFieldTxt = [FORM_VALIDATORS.REQUIRED_FIELD];
  requiredNumberTxt = [FORM_VALIDATORS.NUMBER_FIELD];

  OPERATION_HELP = FORM_ACTION_CONSTANTS.LABELS.OPERATION_HELP;
  ADD_OPERATION = FORM_ACTION_CONSTANTS.LABELS.ADD_OPERATION;
  DELETE_OPERATION = FORM_ACTION_CONSTANTS.LABELS.DELETE_OPERATION;
  OPERATIONS = [
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.ARITHMETIC,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.GET_COUNT,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.LOGIC,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD
  ];

  panel = 0;
  selectedFields: string[] = [];

  addOperation() {
    if (
      this.formToGenerate &&
      (this.formToGenerate as FormStatus).fields.length >
        this.formOperationsArray.length
    ) {
      const formOperation: FormOperation = lodash.cloneDeep(OPERATION_INIT);
      this.$emit(FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.ADD, formOperation);
    } else {
      Snackbar.popInfo(FORM_ACTION_CONSTANTS.SNACKBAR.NO_MORE_OPERATIONS);
    }
  }

  editOperation(formoperation: FormOperation, index: number) {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.UPDATE_ARRAY,
      formoperation,
      index
    );
  }

  deleteOperation(index: number) {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.DELETE_FROM_ARRAY,
      index
    );
  }
}
